module.exports = __webpack_public_path__ + "static/AboutImg-204b6c73416931bc8808edb457ad1f5f.jpg";